export const STANDARD_DOWNPAYMENT_PERCENTAGES: number[] = [5, 10, 15, 20];
export const STANDARD_DOWNPAYMENT_DASHBOARD_PERCENTAGES: number[] = [
  10, 15, 20,
];
export const STANDARD_DOWNPAYMENT_PERCENTAGES_NAMES = [
  'ten',
  'fifteen',
  'twenty',
];
export const PAYMENT_STRUCTURE_WITH_PMI_REACH_PERCENT = 15;

export const DONT_ALLOW_EIN_SEQ = ['123456789', '987654321'];

export const ACCOUNT_LOCKED = 'Locked';
